import { apiClient } from './client'
import { API_ENDPOINTS } from './endpoints'

export type SystemSettingType = 'boolean' | 'number' | 'string'

export async function getSystemSetting(key: string): Promise<string | null> {
  try {
    const response = await apiClient.get(API_ENDPOINTS.systemSettings.get(key))
    const value = response.data?.settingValue ?? response.data?.SettingValue
    return value == null ? null : String(value)
  } catch {
    return null
  }
}

export async function getSystemSettingBool(key: string, fallback = false): Promise<boolean> {
  const value = await getSystemSetting(key)
  if (value == null) return fallback
  return value.toLowerCase() === 'true' || value === '1'
}

export async function getSystemSettingNumber(key: string, fallback = 0): Promise<number> {
  const value = await getSystemSetting(key)
  if (value == null || value === '') return fallback
  const n = Number(value)
  return Number.isFinite(n) ? n : fallback
}

export async function upsertSystemSetting(options: {
  settingKey: string
  settingValue: string
  settingType: SystemSettingType
  description?: string
  descriptionEn?: string
}): Promise<void> {
  await apiClient.post(API_ENDPOINTS.systemSettings.base, {
    settingKey: options.settingKey,
    settingValue: options.settingValue,
    settingType: options.settingType,
    description: options.description,
    descriptionEn: options.descriptionEn,
  })
}

export async function upsertSystemSettingBool(
  key: string,
  value: boolean,
  labels?: { ar?: string; en?: string }
): Promise<void> {
  await upsertSystemSetting({
    settingKey: key,
    settingValue: String(value),
    settingType: 'boolean',
    description: labels?.ar,
    descriptionEn: labels?.en,
  })
}
